export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9108.d911eb10.jpg";